var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-status"},[_c('v-chip',{staticClass:"product-status__chip",attrs:{"color":_vm.status.color,"text-color":"white","label":"","small":""}},[_vm._v(" "+_vm._s(_vm.status.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }